'use client'

import type * as React from 'react'

import { EditorContainer } from './editor-container.atom'
import { EditorLoadingPlaceholder } from './editor-loading-placeholder.atom'
import { useMarkdownEditorSetup } from './hooks/useMarkdownEditorSetup.hook'
import type { MarkdownEditorProps } from './markdown-editor.interface'

import 'tippy.js/dist/tippy.css'

import './markdown-editor.css'

/**
 * Rich text markdown editor with WYSIWYG toolbar and mention support
 */
export const MarkdownEditor: React.FC<MarkdownEditorProps> = (props) => {
  const { editor, isMounted, characterCount } = useMarkdownEditorSetup(props)

  const {
    toolbar = 'complete',
    disabled = false,
    minHeight = '100px',
    maxHeight = 'none',
    className,
    showCharacterCount = false,
    maxLength,
  } = props

  if (!isMounted) {
    return (
      <EditorLoadingPlaceholder minHeight={minHeight} isDisabled={disabled} className={className} />
    )
  }

  return (
    <EditorContainer
      editor={editor}
      toolbar={toolbar}
      isDisabled={disabled}
      minHeight={minHeight}
      maxHeight={maxHeight}
      characterCount={characterCount}
      maxLength={maxLength}
      isShowCharCount={showCharacterCount || !!maxLength}
      className={className}
    />
  )
}

MarkdownEditor.displayName = 'MarkdownEditor'

export type { EditorVariant, MentionItem, ToolbarConfig } from './markdown-editor.interface'
